if (!customElements.get('featued-prodcut')) {
    class featuredProduct extends HTMLElement {
      constructor() {
        super();
  
        const tabSelect = this.querySelector('.tab-mobile-nav');
        const tabButtons = this.querySelectorAll('.featured_btn');
        const tabPanels = this.querySelectorAll('.tabs_article');
  
        tabButtons[0].classList.add('active');
        tabPanels[0].classList.add('active');
  
        tabButtons.forEach((button, index) => {
          button.addEventListener('click', () => {
            activateTab(index);
            updateFeaturedProduct(index);
          });
  
          const option = document.createElement('option');
          option.value = button.getAttribute('data-tab-target');
          option.textContent = button.textContent;
          tabSelect.appendChild(option);
        });
  
        tabSelect.addEventListener('change', () => {
          const selectedIndex = tabSelect.selectedIndex;
          activateTab(selectedIndex);
          updateFeaturedProduct(selectedIndex);
        });
  
        function activateTab(index) {
          tabButtons.forEach((button) => {
            button.classList.remove('active');
          });
          tabPanels.forEach((panel) => {
            panel.classList.remove('active');
          });
  
          tabButtons[index].classList.add('active');
          tabPanels[index].classList.add('active');
          tabSelect.selectedIndex = index;
        }
  
        function updateFeaturedProduct(index) {
          const featuredProduct = document.querySelector('.featured_prodcut');  
          if (featuredProduct) {                
            const itemBg = tabButtons[index].getAttribute('data-bg');
            featuredProduct.style.setProperty('--item-bg', itemBg);
          }
          
        }
      }
    }
  
    customElements.define('featued-prodcut', featuredProduct);
}